import { SectionConfig, SectionType, RelationRowData } from './types';

export const TERM_TO_TERM: SectionType = 'termsToTerms';
export const TERM_TO_NODE: SectionType = 'termsToNodes';
export const NODE_TO_NODE: SectionType = 'nodesToNodes';

export const SYSTEM = 'System';
export const CUSTOM = 'Custom';
export const SYSTEM_TOOLTIP = 'System defined relationships cannot be deleted.';
export const CUSTOM_TOOLTIP = 'Custom defined relationships that are in use cannot be deleted.';

export const SYSTEM_TERM_TO_TERM_RELATIONS = [
    { name: 'Contains', inverseName: 'Contained By' },
    { name: 'Inherits', inverseName: 'Inherited By' },
    { name: 'Type Of', inverseName: 'Has Type' },
    { name: 'Utilized By', inverseName: 'Utilized In' },
    { name: 'Associated With', inverseName: 'Has Association' },
];

// Reserved system relation names (cannot be used for custom types)
export const RESERVED_RELATION_NAMES = new Set(
    SYSTEM_TERM_TO_TERM_RELATIONS.flatMap((rel) => [rel.name.toLowerCase(), rel.inverseName.toLowerCase()]),
);

export const SECTION_CONFIGS: SectionConfig[] = [
    {
        section: TERM_TO_TERM,
        sourceLabel: 'Glossary Terms',
        targetLabel: 'Glossary Terms',
        description:
            'Define the forward relationship on the left and the corresponding inverse (reciprocal) relationship on the right.',
    },
    {
        section: TERM_TO_NODE,
        sourceLabel: 'Glossary Terms',
        targetLabel: 'Glossary Nodes',
        description:
            'Define the forward relationship on the left and the corresponding inverse (reciprocal) relationship on the right.',
    },
    {
        section: NODE_TO_NODE,
        sourceLabel: 'Glossary Nodes',
        targetLabel: 'Glossary Nodes',
        description:
            'Define the forward relationship on the left and the corresponding inverse (reciprocal) relationship on the right.',
    },
];

export const ENTITY_TYPE_MAP = {
    [TERM_TO_TERM]: { sourceEntityType: 'glossaryTerm', targetEntityType: 'glossaryTerm' },
    [TERM_TO_NODE]: { sourceEntityType: 'glossaryTerm', targetEntityType: 'glossaryNode' },
    [NODE_TO_NODE]: { sourceEntityType: 'glossaryNode', targetEntityType: 'glossaryNode' },
} as const;

export const ALL_SECTIONS: SectionType[] = [TERM_TO_TERM, TERM_TO_NODE, NODE_TO_NODE];

export const INITIAL_EMPTY_SYSTEM_ROW: RelationRowData = {
    id: 'system-empty',
    relation_type: SYSTEM,
    relation_type_of: 'Type Of',
    icon: true,
    relation_has_type: 'Has Type',
    action: { tooltip: SYSTEM_TOOLTIP },
};

// Row ID prefixes
export const NEW_ROW_PREFIX = 'new-';
export const SYSTEM_ROW_PREFIX = 'system-';

// Helper function to check if a row is a system type
export const isSystemType = (type: string): boolean => type === SYSTEM;

// UI Constants
export const PLACEHOLDER_TYPE_OF = 'Type Of';
export const PLACEHOLDER_HAS_TYPE = 'Has Type';
export const INFO_ICON_COLOR = '#8c8c8c';
